import React from "react";
import { Check, X } from "lucide-react";

const ROWS = [
  { label: "Compliance built into workflow (not bolted on)", us: true, them: false },
  { label: "Central visibility across all verifications", us: true, them: false },
  { label: "Connected with CoSec App & company secretarial work", us: true, them: false },
  { label: "Mobile-optimised, on-brand client experience", us: true, them: false },
  { label: "Signed, inspection-ready audit trails", us: true, them: false },
  { label: "Manual spreadsheets & email chases", us: false, them: true },
];

export default function Differentiators() {
  return (
    <section className="py-20 md:py-28 bg-primary text-primary-foreground relative overflow-hidden">
      <div className="absolute inset-0 bg-dotgrid opacity-[0.07] pointer-events-none" />
      <div className="absolute -top-32 -left-32 h-96 w-96 rounded-full bg-accent/20 blur-3xl pointer-events-none" />

      <div className="container-cv relative">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-accent">
            <span className="h-px w-8 bg-accent" /> Why CoVerify
          </span>
          <h2 className="mt-4 font-display text-3xl md:text-5xl font-bold tracking-tight leading-[1.1]">
            Connected by design.{" "}
            <span className="text-accent">Compliant by default.</span>
          </h2>
          <p className="mt-5 text-base md:text-lg text-white/70 max-w-2xl">
            CoVerify is part of the wider CoSec Global ecosystem, built specifically for
            compliance-driven professional work. That means fewer missed steps and
            greater confidence as ID verification requirements evolve.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          <div className="rounded-2xl border border-accent/40 bg-white/5 backdrop-blur p-6 md:p-8">
            <div className="flex items-center gap-3">
              <div className="h-2 w-2 rounded-full bg-accent" />
              <div className="font-display font-bold uppercase tracking-wider text-sm">CoVerify</div>
            </div>
            <ul className="mt-6 space-y-4">
              {ROWS.map((r, i) => (
                <li key={i} className="flex items-start gap-3">
                  {r.us ? (
                    <span className="grid h-6 w-6 place-items-center rounded-full bg-accent text-primary mt-0.5">
                      <Check className="h-4 w-4" />
                    </span>
                  ) : (
                    <span className="grid h-6 w-6 place-items-center rounded-full bg-white/10 text-white/40 mt-0.5">
                      <X className="h-4 w-4" />
                    </span>
                  )}
                  <span className={`text-sm md:text-base ${r.us ? "text-white" : "text-white/40 line-through"}`}>
                    {r.label}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-6 md:p-8">
            <div className="flex items-center gap-3">
              <div className="h-2 w-2 rounded-full bg-white/30" />
              <div className="font-display font-bold uppercase tracking-wider text-sm text-white/60">Disconnected Tools</div>
            </div>
            <ul className="mt-6 space-y-4">
              {ROWS.map((r, i) => (
                <li key={i} className="flex items-start gap-3">
                  {r.them ? (
                    <span className="grid h-6 w-6 place-items-center rounded-full bg-white/10 text-white/70 mt-0.5">
                      <Check className="h-4 w-4" />
                    </span>
                  ) : (
                    <span className="grid h-6 w-6 place-items-center rounded-full bg-white/[0.04] text-white/30 mt-0.5">
                      <X className="h-4 w-4" />
                    </span>
                  )}
                  <span className={`text-sm md:text-base ${r.them ? "text-white/70" : "text-white/30"}`}>
                    {r.label}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
